<template>
    <f7-page name="Comment Replies">
        <f7-navbar
            large
            title-large="Replies"
        >
            <f7-nav-left>
                <f7-link
                    icon="ion-ios-arrow-left"
                    @click="backCloseIfLast"
                />
                <!--   -->
            </f7-nav-left>
            <f7-nav-title>Replies</f7-nav-title>
        </f7-navbar>

        <f7-messages ref="messages">

            <f7-messages-title />
            <div
                style="text-align: left; padding-left: 20px"
                class="message-name"
            >{{ comment.name }} <span
                    v-if="comment.user.forumTitle"
                    class="forumTitle"
                >- {{ comment.user.forumTitle }}</span><span v-if="user.isAdmin">{{ formatDate(comment.createdAt) }}</span></div>
            <!-- <f7-messages-title>In reply to<br>
                <div style="max-width: 250px; margin: 10px auto; font-weight: bold">{{ question.title }}</div>
            </f7-messages-title> -->
            <f7-message
                :name="comment.name"
                :type="comment.userId === user.id ? 'sent' : 'received'"
                :text="comment.text"
                tail
                last
            />

            <!-- <f7-messages-title v-if="messagesData.length">Replies</f7-messages-title> -->
            <f7-messages-title
                v-if="unit.description"
                style="font-size: 16px"
            >
                <br>{{ unit.description }}<br><br>
            </f7-messages-title>
            <f7-messages-title v-if="loaded && messagesData.length === 0">
                <br><br>No replies yet.<br><br>Be the first!
            </f7-messages-title>

            <f7-message
                v-for="(message, index) in messagesData"
                :key="index"
                :type="message.userId === user.id ? 'sent' : 'received'"
                :image="message.image"
                :avatar="message.avatar"
                :first="isFirstMessage(message, index)"
                :last="isLastMessage(message, index)"
                :tail="isTailMessage(message, index)"
            >
                <div slot="name">{{ message.name }} <span v-html="formatDate(message.createdAt)" /></div>
                <div
                    slot="text"
                    class="selectable"
                    v-html="message.text"
                />
                <div
                    slot="bubble-end"
                    class="message-footer"
                >
                    <a
                        v-if="message.userId !== user.id"
                        href="#"
                        @click="doLike(message)"
                    >Like{{ message.liked ? 'd' : '' }} ({{ message.likesTotal }})</a>
                    <a
                        v-if="message.userId !== user.id "
                        href="#"
                        @click="reply(message)"
                    >Reply</a>
                    <a
                        href="#"
                        class="more"
                        @click="more(message)"
                    ><i class="ion ion-more" /></a>
                </div>
            </f7-message>
            <br><br><br>
        </f7-messages>

        <f7-messagebar
            ref="messagebar"
            :placeholder="'Add a reply...'"
            :attachments-visible="mentionIsOpen"
            class="messagebar"
            @input="textChange"
        >
            <f7-messagebar-attachments>
                <div style="height: 100px">
                    <div
                        v-for="(username, index) in mentionUsers"
                        :key="index"
                        class="mentionItem"
                        @click="addAsMention(username)"
                    >@{{ username }}</div>
                </div>
            </f7-messagebar-attachments>
            <f7-link
                slot="inner-end"
                icon="ion-ios-arrow-thin-right"
                class="blackLink"
                @click="sendMessage"
            />
        </f7-messagebar>
    </f7-page>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';

import utils from '../../js/utils';

export default {
    store: ['api', 'user', 'partners'],
    data () {
        return {
            loaded: false,
            comment: {
                id: 0,
                text: '',
                name: '',
                user: {
                    name: '',
                    username: '',
                },
                createdAt: moment(),
            },
            unit: {
                id: 0,
                name: '',
                description: '',
            },
            currentId: 0,
            comments: [],
            messagesData: [],
            mentionIsOpen: false,
            mentionUsers: [],
            mentionedUsers: [],
        };
    },
    computed: {},
    created: function () { },
    mounted: function () {
        this.$f7ready(() => {
            this.messagebar = this.$refs.messagebar.f7Messagebar;
            this.messages = this.$refs.messages.f7Messages;
        });
        if (this.$f7route.params.id) {
            this.currentId = parseFloat(this.$f7route.params.id);
        }
        this.getComments();
        this.getComment();
    },
    methods: {
        textChange: function (e) {
            if (e.data === '@' && !this.mentionIsOpen) {
                this.mentionIsOpen = true;
            }
            if (e.data === ' ' && this.mentionIsOpen) {
                this.mentionIsOpen = false;
            }
            if (e.data === null && this.mentionIsOpen) {
                //  backspace
                this.mentionIsOpen = false;
            }
            if (e.target.value.length === 0) this.mentionIsOpen = false;
            if (this.mentionIsOpen && e.data !== '@') {
                var caratPos = this.messagebar.textareaEl.selectionStart,
                    tmpStr = this.messagebar.getValue(),
                    i;
                for (i = caratPos; i >= 0; i--) {
                    if (tmpStr[i] == '@') {
                        break;
                    }
                }


                var searchTerm = tmpStr.substring(caratPos, i + 1);
                // reset to context mention users
                this.resetMentionUsers();
                if (searchTerm.length > 0) {
                    // OneVoice code this.findMentions(searchTerm);
                    this.mentionUsers = _.filter(this.mentionUsers, function (item) {
                        return _.startsWith(item, searchTerm);
                    });
                }
            }
        },
        // since this code was copied from OneVoice, where usernames are public
        // findMentions: _.debounce(function (q) {
        //     this.$http.get(`${this.api}/users?q=${q}&limit=4`).then(
        //         (response) => {
        //             this.mentionUsers = response.body;
        //         },
        //         () => {
        //         }
        //     );
        // }, 100),
        resetMentionUsers: function () {
            this.mentionUsers = [];
            for (let i = 0; i < this.partners.length; i++) {
                const p = this.partners[i];
                if (this.mentionUsers.indexOf(p.username) === -1 && p.username !== 'etienne')
                    this.mentionUsers.push(p.username);
            }
            for (let i = 0; i < this.messagesData.length; i++) {
                const comment = this.messagesData[i];
                if (this.mentionUsers.indexOf(comment.user.username) === -1 && comment.user.username !== 'etienne')
                    this.mentionUsers.push(comment.user.username);
            }
        },
        addAsMention: function (username) {
            this.mentionedUsers.push(username);
            var caratPos = this.messagebar.textareaEl.selectionStart,
                tmpStr = this.messagebar.getValue(),
                i;
            for (i = caratPos; i >= 0; i--) {
                if (tmpStr[i] == '@') {
                    break;
                }
            }
            tmpStr.substring(i, caratPos)
            var textBefore = tmpStr.substring(0, i),
                textAfter = tmpStr.substring(caratPos),
                newStr = textBefore + '@' + username + textAfter;

            // insert:
            this.messagebar.setValue(newStr);

            // move cursor:
            setTimeout(() => {
                caratPos += username.length;
                this.messagebar.textareaEl.selectionStart = this.messagebar.textareaEl.selectionEnd = caratPos;
                this.mentionIsOpen = false;
                this.messagebar.focus();
            }, 10);
        },
        backCloseIfLast: function () {
            if (this.$f7router.view.main) {
                if (f7.views['main'].router.history.length === 1) {
                    f7.views['main'].router.navigate('/home');
                } else {
                    f7.views['main'].router.back();
                }
            } else {
                if (f7.views['popup'].router.history.length === 1) {
                    if (f7.popup.get(`#${this.$f7router.view.name}`)) {
                        f7.popup.get(`#${this.$f7router.view.name}`).open();
                        f7.popup.get(`#${this.$f7router.view.name}`).close();
                    }
                    return;
                }
                setTimeout(() => {
                    this.$f7router.view.router.back();
                }, 100);

            }
        },
        more: function (message) {
            const buttons = [];
            if (message.userId === this.user.id) {
                buttons.push({
                    text: 'Delete',
                    color: 'red',
                    onClick: () => {
                        this.doDelete(message)
                    }
                });
            } else {
                buttons.push({
                    text: 'Flag as inappropriate',
                    onClick: () => {
                        this.doFlag(message);
                    }
                });
            }

            f7.actions
                .create({
                    title: 'Comment options',
                    buttons: [buttons, [{
                        text: 'Cancel',
                        onClick: () => {

                        }
                    }]]
                })
                .open();
        },
        formatDate: function (date) {
            // moment.locale('en', {
            //     relativeTime: {
            //         future: 'in %s',
            //         past: '%s ago',
            //         s: 'seconds',
            //         ss: '%ss',
            //         m: 'a minute',
            //         mm: '%dm',
            //         h: 'an hour',
            //         hh: '%dh',
            //         d: 'a day',
            //         dd: '%dd',
            //         M: '1M',
            //         MM: '%dM',
            //         y: 'a year',
            //         yy: '%dy'
            //     }
            // });
            return moment(date).utc().fromNow();
        },
        doDelete: function (comment) {
            if (comment.userId !== this.user.id) return;
            this.$http['delete'](`${this.api}/comments/${comment.id}`);
            for (let i = 0; i < this.messagesData.length; i++) {
                const element = this.messagesData[i];
                if (element.id === comment.id) {
                    this.messagesData.splice(i, 1);
                    break;
                }
            }
        },
        doLike: function (message) {
            if (!this.user.username) {
                this.$f7router.view.router.navigate(`/username?view=${this.$f7router.view.name}`);
                return;
            }
            if (message.userId === this.user.id) return;
            message.liked = !message.liked;

            this.$http[message.liked ? 'post' : 'delete'](`${this.api}/comments/${message.id}/like`).then(
                () => {
                    if (message.liked) {
                        message.likesTotal++;
                    } else {
                        message.likesTotal--;
                    }
                },
                response => {
                    utils.failedRequest('popup', response);
                }
            );
        },
        doFlag: function (comment) {
            if (comment.userId === this.user.id) return;
            this.$http['post'](`${this.api}/comments/${comment.id}/flag`);
            for (let i = 0; i < this.messagesData.length; i++) {
                const element = this.messagesData[i];
                if (element.id === comment.id) {
                    this.messagesData.splice(i, 1);
                    break;
                }
            }
        },
        getComments: function () {
            this.$http.get(`${this.api}/comments/${this.currentId}/replies`).then(
                response => {
                    if (response.body.length > 0)
                        this.messagesData = this.renderComments(response.body);
                    this.resetMentionUsers();
                    this.loaded = true;
                },
                (response) => {
                    this.messagesData = [];
                    utils.failedRequest('popup', response);
                }
            );
        },
        getUnit: function () {
            this.$http.get(`${this.api}/units/${this.comment.unitId}`).then(
                response => {
                    this.unit = response.body;
                },
                (response) => {
                    utils.failedRequest('popup', response);
                }
            );
        },
        getComment: function () {
            this.$http.get(`${this.api}/comments/${this.currentId}`).then(
                response => {
                    this.comment = this.renderComments([response.body])[0];
                },
                (response) => {
                    utils.failedRequest('popup', response);
                }
            );
        },
        renderComments: function (comments) {
            for (let i = 0; i < comments.length; i++) {
                const comment = comments[i];
                comment.name = comment.user.username;
                if (comment.user.id === 15) comment.name = comment.username;
                if (comment.answer) {
                    // console.log(comment.answer, this.question.answers);
                    if (this.question.type === 'multi') {
                        comment.color = this.question.answers[comment.answer.choiceInt].color;
                    } else if (this.question.type === 'stars') {
                        comment.color = 'yellow';
                    } else if (this.question.type === 'number') {
                        comment.color = 'blue';
                    }
                }
            }
            return comments;
        },
        isFirstMessage (message, index) {
            const previousMessage = this.messagesData[index - 1];
            if (message.isTitle) return false;
            if (!previousMessage || previousMessage.type !== message.type || previousMessage.name !== message.name)
                return true;
            return false;
        },
        isLastMessage (message, index) {
            const nextMessage = this.messagesData[index + 1];
            if (message.isTitle) return false;
            if (!nextMessage || nextMessage.type !== message.type || nextMessage.name !== message.name) return true;
            return false;
        },
        isTailMessage (message, index) {
            const nextMessage = this.messagesData[index + 1];
            if (message.isTitle) return false;
            if (!nextMessage || nextMessage.type !== message.type || nextMessage.name !== message.name) return true;
            return false;
        },
        reply: function (message) {
            this.messagebar.clear().setValue(`@${message.user.username} `).focus();
            //this.messagebar.focus();
        },
        sendMessage: function () {
            if (!this.user.username) {
                this.$f7router.view.router.navigate(`/username?view=${this.$f7router.view.name}`);
                return;
            }
            const text = this.messagebar
                .getValue()
                .replace(/\n/g, '<br>')
                .trim();
            if (text.length === 0) {
                // exit when empty messagebar text is empty
                return;
            }
            // Clear messagebar area
            this.messagebar.clear();
            // Focus area
            if (text.length) this.messagebar.focus();
            // Add sent message
            this.messagesData.push(
                this.renderComments([
                    {
                        text,
                        user: this.user,
                        userId: this.user.id,
                        id: 999,
                    },
                ])[0]
            );
            this.$http
                .post(`${this.api}/units/${this.comment.unitId}/comments`, {
                    text,
                    unitId: this.comment.unitId,
                    parentId: this.currentId,
                })
                .then(() => {
                    this.$events.fire('trackEvent', `commented`, 'actions', this.comment.unitId, 'RE: ' + this.unit.name);
                }, () => { });
        },
        onF7Ready () {
            // References to us APIs
            this.messagebar = this.$refs.messagebar.f7Messagebar;
            this.messages = this.$refs.messages.f7Messages;
        },
    },
};
</script>

<style lang="less" scoped>
@import '../../css/colors.less';
.comment {
    padding: 6px 20px 0 0;
    position: relative;
}
.like {
    position: absolute;
    top: -4px;
    right: -10px;
    padding: 10px;
    i {
        font-size: 20px;
        color: @black;
    }
}
.title {
    font-weight: bold;
    font-size: 15px;
    line-height: 14px;
}
.text {
    font-size: 15px;
    line-height: 14px;
}
.after {
    font-size: 15px;
    line-height: 14px;
    font-weight: bold;
}
.replies.link {
    color: black;
    font-size: 14px;
    font-weight: bold;
    padding-bottom: 6px;
}
.more {
    padding: 0 14px 0 10px;
    i.ion {
        line-height: 12px;
        font-size: 15px;
    }
}
.mentionItem {
    height: 27px;
    color: black;
    line-height: 20px;
    font-size: 13px;
    padding: 0px;
    margin: 0px;
}
.forumTitle {
    color: #fc6f65;
    letter-spacing: -0.1px;
}
</style>
